import Loadable from "@loadable/component";

export const LoadableP5 = Loadable(() => import('react-p5-wrapper'));